// External libraries
import { QueryClient, QueryFunction } from "@tanstack/react-query";

// Internal imports

// Token getter for queries - will be set by auth store
let tokenGetter: () => string | null = () => null;

export function setQueryTokenGetter(getter: () => string | null) {
  tokenGetter = getter;
}

async function throwIfResNotOk(res: Response) {
  if (!res.ok) {
    const text = (await res.text()) || res.statusText;
    throw new Error(`${res.status}: ${text}`);
  }
}

export async function apiRequest(
  method: string,
  url: string,
  data?: unknown | undefined,
): Promise<Response> {
  const headers: Record<string, string> = {};

  if (data) {
    headers["Content-Type"] = "application/json";
  }

  const token = tokenGetter();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    method,
    headers,
    body: data ? JSON.stringify(data) : undefined,
    credentials: "include",
  });

  await throwIfResNotOk(res);
  return res;
}

export const defaultQueryFn: QueryFunction = async ({ queryKey }) => {
  // Build URL properly - first element is base path, second is query params
  const base = (import.meta as any).env?.VITE_API_URL || "";
  let url = `${base}${queryKey[0] as string}`;
  if (queryKey.length > 1 && queryKey[1]) {
    url += `?${queryKey[1]}`;
  }

  const headers: Record<string, string> = {};
  const token = tokenGetter();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    credentials: "include",
    headers,
  });

  await throwIfResNotOk(res);
  return await res.json();
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
